module.exports = "<span class=\"js-text reference-field__txt btn-wrp\" title={{text}}> {{#if text}} {{text}} {{else}} <span class=member-text__empty>{{localize 'CORE.FORM.EDITORS.MEMBERSELECT.NOTSET'}}</span> {{/if}} </span> <div class=svg-icons-wrp> <div class=\"js-clear-button svg-icons-wrp__remove\"> <svg class=\"svg-icons svg-icons_remove\"><use xlink:href=#icon-remove /> </svg> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/reference/templates/userReferenceButton.hbs
// module id = 679
// module chunks = 0